var _path, _g, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBulbIcon = function SvgBulbIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M24 33C32.2843 33 39 26.2843 39 18C39 9.71573 32.2843 3 24 3C15.7157 3 9 9.71573 9 18C9 26.2843 15.7157 33 24 33Z",
    fill: "#0A9928"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3 18L19.1 31H23.3L20.7 22H27.3L24.7 31H28.9L32.7001 18H15.3Z",
    fill: "#0A9928"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 40H19L16.5 31H31.5L29 40Z",
    fill: "#0A9928"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M19 40H29C29 42.8 26.8 45 24 45C21.2 45 19 42.8 19 40Z",
    fill: "#0A9928"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBulbIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "bulb_icon.3893cbcb0ef9c1bb1dbb1c0a411eaee4.svg";